import cs from "./cs.i18n";
import de from "./de.i18n";
import en from "./en.i18n";
import sk from "./sk.i18n";

export default {
  cs,
  de,
  en,
  sk
};
